import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, mergeProps as _mergeProps, vShow as _vShow } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_2 = {
    key: 0,
    class: "bottom10"
};
const _hoisted_3 = { class: "mt-0" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_7 = { class: "input-group top_search" };
const _hoisted_8 = { class: "col-sm-12 col-md-6" };
const _hoisted_9 = { class: "clearfix" };
const _hoisted_10 = {
    key: 0,
    class: "btn-group pw100 bottom10"
};
const _hoisted_11 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_14 = { class: "col-xs-12 col-sm-6 col-md-6 bottom10" };
const _hoisted_15 = { class: "invalid-feedback" };
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_17 = { class: "checkbox-wrapper" };
const _hoisted_18 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.reportScheduledModel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, [
                        _cache[7] || (_cache[7] = _createTextVNode("Editing schedule report ", -1 /* CACHED */)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.reportScheduledModel.description), 1 /* TEXT */)
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _cache[28] || (_cache[28] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedCompanyId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                    options: _ctx.companies,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "All companies",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _cache[29] || (_cache[29] = _createTextVNode()),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedSite,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedSite) = $event)),
                    options: _ctx.sitesFiltered,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "All sites",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _cache[30] || (_cache[30] = _createTextVNode()),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _cache[16] || (_cache[16] = _createElementVNode("label", null, "Period", -1 /* CACHED */)),
                _cache[17] || (_cache[17] = _createTextVNode()),
                (!_ctx.showDatePickers)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                            return _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                                class: "pw100",
                                key: idx,
                                variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                onClick: ($event) => (_ctx.setDateFilterOption(item)),
                                title: _ctx.getPeriodTitle(item)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["variant", "onClick", "title"])), [
                                [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                ]
                            ]);
                        }), 128 /* KEYED_FRAGMENT */))
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[18] || (_cache[18] = _createTextVNode()),
                (_ctx.showDatePickers)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_b_input_group, {
                                class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_flat_pickr, {
                                        class: "form-control",
                                        modelValue: _ctx.startTime,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.startTime) = $event)),
                                        config: _ctx.datePickerConfig,
                                        placeholder: "Select date"
                                    }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                    _cache[11] || (_cache[11] = _createTextVNode()),
                                    _createVNode(_component_b_input_group_append, null, {
                                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn btn-default",
                                                        "data-toggle": ""
                                                    }, [
                                                        _createElementVNode("i", { class: "fa fa-calendar" })
                                                    ])
                                                ], -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["class"])
                        ]),
                        _cache[15] || (_cache[15] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_b_input_group, {
                                class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_flat_pickr, {
                                        class: "form-control",
                                        modelValue: _ctx.endTime,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.endTime) = $event)),
                                        config: _ctx.datePickerConfig,
                                        placeholder: "Select date"
                                    }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                    _cache[14] || (_cache[14] = _createTextVNode()),
                                    _createVNode(_component_b_input_group_append, null, {
                                        default: _withCtx(() => [
                                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn-default",
                                                    "data-toggle": ""
                                                }, [
                                                    _createElementVNode("i", { class: "fa fa-calendar" })
                                                ])
                                            ], -1 /* CACHED */)),
                                            _cache[13] || (_cache[13] = _createTextVNode()),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-secondary",
                                                onClick: _cache[4] || (_cache[4] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                            }, "\r\n\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["class"])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ])
        ]),
        _cache[31] || (_cache[31] = _createTextVNode()),
        _createElementVNode("div", _hoisted_14, [
            _cache[19] || (_cache[19] = _createElementVNode("label", null, "Minimum Discharge Duration (seconds)", -1 /* CACHED */)),
            _cache[20] || (_cache[20] = _createTextVNode()),
            _createVNode(_component_b_form_input, _mergeProps(_ctx.minDischargeDurationVal, {
                modelValue: _ctx.minDischargeDuration,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.minDischargeDuration) = $event)),
                type: "number",
                step: "1",
                min: "0",
                max: "3600",
                class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.minDischargeDuration }
            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
            _cache[21] || (_cache[21] = _createTextVNode()),
            _withDirectives(_createElementVNode("div", _hoisted_15, "\r\n\t\t\t* Please enter a value between 0 and 3600 Seconds.\r\n\t\t", 512 /* NEED_PATCH */), [
                [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.minDischargeDuration]
            ])
        ]),
        _cache[32] || (_cache[32] = _createTextVNode()),
        _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.reportByString,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.reportByString) = $event)),
                    size: "lg"
                }, {
                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                            _createTextVNode("\r\n\t\t\t\tReport by String\r\n\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ])
        ]),
        _cache[33] || (_cache[33] = _createTextVNode()),
        _createElementVNode("div", _hoisted_18, [
            _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.schedule
            }, {
                default: _withCtx(() => [
                    _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getScheduleButtonLabel()), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])), [
                [_directive_standard_or_higher]
            ]),
            _cache[26] || (_cache[26] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.exportToPdf
            }, {
                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                        _createTextVNode(" Export PDF\r\n\t\t", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]),
            _cache[27] || (_cache[27] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.exportToCsv
            }, {
                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                        _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                        _createTextVNode(" Export CSV\r\n\t\t", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
        ]),
        _cache[34] || (_cache[34] = _createTextVNode()),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ], 64 /* STABLE_FRAGMENT */));
}
